import { AxiosRequestConfig } from "axios";
import { ApiService } from "../../../config";
import { handleError } from "../../../utils/parseApiReturn";
import { toast } from "react-toastify";
import type { ISearchTermsGrowth } from "../types";

const getProfile = async (
  profileId: string,
  daysToFilter: number
): Promise<any> => {
  try {
    const config: AxiosRequestConfig = {
    };
    const response = await ApiService.get(
      `/dashboard/profile/${profileId}?daysToFilter=${daysToFilter}`,
      config
    );
    const { data, error } = response.data;
    if (error) {
      toast.error("Não foi possível recuperar os dados da conta");
      return null;
    } else {
      return data;
    }
  } catch (error) {
    const { message } = handleError(
      error,
      "Não foi possível carregar os planos."
    );
    toast.error(message);
    return [];
  }
};

/** Termos de busca do Google mês a mês. Falha vira null: o bloco mostra aviso, a página segue. */
const getSearchTermsGrowth = async (
  profileId: string,
  months = 12,
): Promise<ISearchTermsGrowth | null> => {
  try {
    const response = await ApiService.get(
      `/dashboard/profile/${profileId}/search-terms`,
      { params: { months } },
    );
    const { data, error } = response.data;
    return error ? null : (data as ISearchTermsGrowth);
  } catch {
    return null;
  }
};

export const DashboardService = {
  getProfile,
  getSearchTermsGrowth,
};
